import { AssetMapper } from './asset.mapper';
import { LandingPage } from '..';

export class LandingPageMapper {
  public static mapItems(landingPages: LandingPage[]): LandingPage[] {
    return landingPages.map(LandingPageMapper.mapItem);
  }
  public static mapItem(landingPage: LandingPage): LandingPage {
    landingPage.logo = landingPage.logo
      ? AssetMapper.mapItem(landingPage.logo, landingPage.id.toString())
      : null;
    landingPage.imageUrl = landingPage.logo
      ? landingPage.logo.imageUrl
      : 'assets/images/no-image-available.png';
    landingPage.mobileImage = landingPage.mobileImage
      ? AssetMapper.mapItem(landingPage.mobileImage, landingPage.id.toString())
      : null;

    return landingPage;
  }
}
